import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative flex flex-col items-center bg-white shadow-lg rounded-xl p-4 overflow-hidden flex-1 w-full" }
const _hoisted_2 = { class: "relative flex flex-col items-center w-full space-y-3 flex-1" }
const _hoisted_3 = { class: "text-xs font-semibold text-white px-2 py-0 rounded-full uppercase" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "w-28 h-28 object-fi rounded-full border-2 border-white shadow-md flex items-center justify-center font-semibold text-3xl text-gray-700 bg-[radial-gradient(circle,_white_0%,_#d1d5db_100%)]"
}
const _hoisted_6 = { class: "leading-none text-gray-500 mb-1 text-xl" }
const _hoisted_7 = { class: "space-y-0 pt-1" }
const _hoisted_8 = { class: "text-base font-bold text-gray-800 text-center" }
const _hoisted_9 = { class: "text-sm text-gray-500 text-center" }
const _hoisted_10 = {
  key: 2,
  class: "w-full space-y-0 pt-1 pb-4"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "flex flex-col items-center space-y-1 justify-center pt-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "w-10 h-10 rounded-full border border-[#bbc1a9] bg-gray-300"
}
const _hoisted_16 = { class: "text-sm text-gray-500 font-semibold leading-none" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DetalleEmpresaView = _resolveComponent("DetalleEmpresaView")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-[#424c42] via-[#bbc1a9] to-white" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.itemMeeting.acreditado.tipoAcreditado.descripcion), 1),
        (_ctx.itemMeeting.acreditado.foto)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.itemMeeting.acreditado.foto,
              class: "w-28 h-28 object-scale-down rounded-full border-2 border-white shadow-md bg-white"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.iniciales(_ctx.itemMeeting.acreditado.nombre, _ctx.itemMeeting.acreditado.apellido)), 1)
            ])),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.itemMeeting.acreditado.nombre + " " + _ctx.itemMeeting.acreditado.apellido), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.itemMeeting.acreditado.cargo || 'N/A'), 1)
        ]),
        (_ctx.usarResumenAcreditado)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _withDirectives(_createElementVNode("p", {
                class: "text-sm text-gray-500 text-center line-clamp-3",
                innerHTML: _ctx.itemMeeting.resumenAcreditado || ' '
              }, null, 8, _hoisted_11), [
                [
                  _directive_tooltip,
                  {value: _ctx.itemMeeting.resumenAcreditado, escape: false,   pt: { text: { style: { minWidth: '400px' } }}},
                  void 0,
                  { top: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.usarPerfilEmpresas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_ctx.itemMeeting.empresa && _ctx.itemMeeting.empresa.previewLogo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.itemMeeting.empresa.previewLogo,
                      class: "w-10 h-10 rounded-full border border-[#bbc1a9] object-cover bg-white"
                    }, null, 8, _hoisted_14))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15)),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.itemMeeting.empresa?.nombreFantasia || 'Sin empresa'), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mostrarDetalleEmpresaAcreditado && _ctx.mostrarDetalleEmpresaAcreditado(...args))),
                  class: "text-[#424c42] text-xs inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-circle-plus'] }),
                  _cache[2] || (_cache[2] = _createTextVNode(" INFO "))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("button", {
          disabled: !_ctx.permiteSolicitarReuniones,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.solicitarReunion && _ctx.solicitarReunion(...args))),
          class: "w-full !mt-auto cursor-pointer text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-lg transform transition-transform duration-200 hover:scale-[102%] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:border-gray-300 disabled:text-gray-400"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('boton.solicitar.reunion')), 1)
        ], 8, _hoisted_18)), [
          [
            _directive_tooltip,
            !_ctx.permiteSolicitarReuniones ? 'No tiene permisos para solicitar reuniones. Solo puede aceptar solicitudes' : null,
            void 0,
            { top: true }
          ]
        ])
      ])
    ]),
    (_ctx.detalleEmpresaVisible)
      ? (_openBlock(), _createBlock(_component_DetalleEmpresaView, {
          key: 0,
          empresa: _ctx.empresa,
          closeFunction: _ctx.cerrarDetalleEmpresa
        }, null, 8, ["empresa", "closeFunction"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}